import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { actionCreators as DebtorSearchStoreActionCreators } from '../../../store/DebtorSearchStore';
import { colors } from '../../../colors';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Search from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import { useAppDispatch } from '../../../hooks';
import { Divider, MenuItem, Select } from '@mui/material';

const DebtorSearchDialog = () => {
  const [searchText, setSearchText] = useState('');
  const [searchField, setSearchField] = useState('all');
  const dispatch = useAppDispatch();

  const SEARCH_OPTIONS = [
    { value: 'all', label: 'Alle' },
    { value: 'name', label: 'Navn' },
    { value: 'debtorIds', label: 'Kundenr.' },
    { value: 'nationalIdentityNumber', label: 'Personnr.' },
    { value: 'organizationNumber', label: 'Orgnr.' },
    { value: 'phoneNumbers', label: 'Telefonnr.' },
    { value: 'invoiceNumbers', label: 'Fakturanr.' },
    { value: 'orderNumbers', label: 'Ordrenr.' },
    { value: 'kidNumbers', label: 'KID' },
    { value: 'caseNumbers', label: 'Saksnr.' },
  ];

  const parseSearchCriteriaFromQueryString = (): string | null => {
    if (window.location.search !== undefined) {
      const parsedQueryString = queryString.parse(
        window.location!.search.toLowerCase()
      );
      if (
        parsedQueryString.searchcriteria !== null &&
        parsedQueryString.searchcriteria !== undefined
      ) {
        if (typeof parsedQueryString.searchcriteria === 'string') {
          return parsedQueryString.searchcriteria;
        } else {
          return parsedQueryString.searchcriteria.join(' ');
        }
      }
    }
    return null;
  };

  useEffect(() => {
    const searchCriteria = parseSearchCriteriaFromQueryString();
    if (searchCriteria !== null) {
      setSearchText(searchCriteria);
      dispatch(
        DebtorSearchStoreActionCreators.searchDebtors(searchText, searchField)
      );
    }
  }, []);

  const handleCriteriaChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(
      DebtorSearchStoreActionCreators.searchDebtors(searchText, searchField)
    );
  };

  return (
    <Paper
      sx={{
        padding: '0px',
        margin: '20px auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        height: '60px',
        width: '780px',
        backgroundColor: colors.lightGray,
      }}
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '10px' }}>
        <Select
          value={searchField}
          onChange={(e) => setSearchField(e.target.value)}
          variant="standard"
          disableUnderline
          sx={{ width: '100px' }}
        >
          {SEARCH_OPTIONS.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        <Divider orientation="vertical" flexItem />
        <TextField
          autoFocus={true}
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
          sx={{
            width: '580px',
            margin: 'auto',
          }}
          placeholder="Søk etter fødselsnr, fakturanr, saksnr, navn, tlf, kundenr, ordrenr eller KID (alt + s for fokus) "
          type="search"
          value={searchText}
          onChange={handleCriteriaChange}
          inputProps={{ accessKey: 's', 'data-id': 'searchCriteria' }}
        />
        <IconButton aria-label="Delete" type="submit" data-id="searchSubmit">
          <Search />
        </IconButton>
      </form>
    </Paper>
  );
};

export default DebtorSearchDialog;
